import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { DropdownItem, emptyFunc } from "../../home/models/OtherTypes";
import {
    OrderModel,
    OrderStatus
} from "../models/OrderModel";
import { OrderService } from "../services/OrderService";

export function useOrderVM() {
    const orderService = new OrderService();

    const [order, setOrder] = useState<OrderModel | null>(null);
    const [orders, setOrders] = useState<OrderModel[]>([]);

    const [listHash, setListHash] = useState<number>(0);
    const [selectedInvoice, setSelectedInvoice] = useState<string>("");
    const [showInvoice, setShowInvoice] = useState<boolean>(false);

    const [loading, setLoading] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showOrderConfirmed, setShowOrderConfirmed] = useState(false);
    const [showDeleteConfirmed, setShowDeleteConfirmed] = useState(false);

    const getList = (getCount: boolean) => {
        setLoading(true);
        setOrders([]);
        setListHash(Utils.getRandomKey());

        const request = orderService.getList(OrderStatus.all);
        DataUtils.onRequest(request, onSearchResult);
    }

    const onSearchResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const orders = result.data as OrderModel[];
            setOrders(orders);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    const get = (id: number) => {
        setLoading(true);
        setOrder(null);
        const request = orderService.get(id);
        DataUtils.onRequest(request, onGetResult);
    }

    const onGetResult = (result: IDataResult) => {
        const order = result.data as OrderModel | null | undefined;

        if (order != null) {
            setOrder(order);
        }

        setLoading(false);
    }

    const placeOrder = (id: number) => {
        setLoading(true);

        const onResult = (result: IDataResult) => {
            setLoading(false);

            if (result.status === ResponseStatus.success) {
                setOrder(null);
                setShowDetail(false);
                getList(true);
            }
        }

        if (window.confirm("Would you like to place order?")) {
            const request = orderService.placeOrder(id);
            DataUtils.onRequest(request, onResult);
        }
    }

    const del = (id: number) => {
        setLoading(true);

        const onResult = (result: IDataResult) => {
            setLoading(false);

            if (result.status === ResponseStatus.success) {
                setOrder(null);
                setShowDetail(false);
                getList(true);
            }
        }

        const request = orderService.delete(id);
        DataUtils.onRequest(request, onResult);
    }

    return {
        order, setOrder,
        orders,
        listHash,

        selectedInvoice, setSelectedInvoice,
        showInvoice, setShowInvoice,

        loading, setLoading,
        showAdd, setShowAdd,
        showDetail, setShowDetail,
        showOrderConfirmed, setShowOrderConfirmed,
        showDeleteConfirmed, setShowDeleteConfirmed,

        getList,
        get,
        placeOrder,
        del
    }
}